import React, {useEffect, useState} from 'react';
import axios from "axios";
import cookie from "react-cookies";
import {RECEIVER_COOKIE_KEY} from "../constant";
import {getUser, useUserDispatch} from "../UserContext";
import {Avatar, Box, Button, Container, CssBaseline, TextField, Typography} from "@mui/material";
import {ShoppingCartRounded} from "@mui/icons-material";
import {useHistory} from "react-router-dom";
import logo from '../logo.png'

function SignIn() {
  const userDispatch = useUserDispatch()
  const history = useHistory()
  const [id, setId] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(()=>{
    localStorage.clear()
  }, [])

  const handleLogin = () => {
    setError(false)
    setErrorMessage('')
    console.log('handleLogin ' + id + ' ' + password)

    axios.get(`${process.env.REACT_APP_USER_API_HOST}/user/logIn`, {
      headers: { 'Content-type': 'application/x-www-form-urlencoded', },
      params: { user_email: id, user_pwd: password, }
    },{ withCredentials: true }).then((response) => {
      console.log('resp :', response.data);
      if (response.data.code === 200) {
        cookie.save(RECEIVER_COOKIE_KEY, response.data.info, { path: '/',  maxAge: 31556952});

        getUser(userDispatch)

        history.push('/')
      } else {
        setError(true)
        setErrorMessage('로그인에 실패 하였습니다.')
      }
    }).catch(function (error) {
      console.log(error);
      setError(true)
      setErrorMessage('로그인에 실패 하였습니다.')
    });
  }

  const onKeyPress = (e) => {

    if(e.key === 'Enter'){
      console.log('onKeyPress ' ,e)
      handleLogin()
    }
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div sx={{ m: 10, bgcolor: 'primary.main' }}>
          {/*<ShoppingCartRounded />*/}
          <img src={logo} width={48} height={48}/>
        </div>
        <Typography sx={{mt : 1}} component="h1" variant="h5">
          폴슨 구매 알바
        </Typography>
        <Box noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            error={error}
            fullWidth
            id="email"
            label="이메일"
            name="email"
            autoComplete="email"
            autoFocus
            value={id}
            onChange={(event => setId(event.target.value))}
          />
          <TextField
            onKeyPress={(e)=>onKeyPress(e)}
            error={error}
            helperText={errorMessage}
            margin="normal"
            fullWidth
            name="password"
            label="패스워드"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(event => setPassword(event.target.value))}
          />

          <Button
            onKeyPress={(e)=>onKeyPress(e)}
            type="submit"
            fullWidth
            variant="contained"
            onClick={(e)=>{handleLogin()}}
            sx={{ mt: 3, mb: 2 }}
          >
            로그인
          </Button>
        </Box>
      </Box>
    </Container>
  );
}


export default SignIn